import { createSlice } from "@reduxjs/toolkit";

const saveSpaceSlice = createSlice({
  name: "save_space_List",
  initialState: [],
  reducers: {
    setSpaceList: (_state, action) => action.payload,
  },
});

export const { setSpaceList } = saveSpaceSlice.actions;

export const save_space_List = saveSpaceSlice.reducer;

export default saveSpaceSlice.reducer;
